import type { AttributeType } from "@aws-sdk/client-cognito-identity-provider";
import type { AuthUser } from "./auth-user";

// const nameMappings: { readonly [key in keyof AuthProfile]: string } = {
// Mapping typing of object.entries didn't work

type UpdatableUserProps = Pick<
	AuthUser,
	| "firstName"
	| "middleName"
	| "lastName"
	| "country"
	| "howHeard"
	| "birthdate"
	| "originSite"
	| "currentSite"
	| "ipAddress"
	| "ipAddressCountry"
	| "emailAddress"
>;

const nameMappings: ReadonlyArray<
	Readonly<[keyof UpdatableUserProps, string, (value: string) => any, boolean]>
> = [
	["firstName", "given_name", String, true],
	["middleName", "middle_name", String, true],
	["lastName", "family_name", String, true],
	["country", "custom:country", String, true],
	["howHeard", "custom:how_heard", String, true],
	["emailAddress", "email", String, true],
	["birthdate", "birthdate", String, true],
	["originSite", "custom:origin_site", String, true],
	["currentSite", "custom:current_site", String, true],
	["ipAddress", "custom:ip_address", String, true],
	["ipAddressCountry", "custom:ip_address_country", String, true],
];

function profileToCognitoAttributes(
	profile: Partial<UpdatableUserProps>,
): AttributeType[] {
	return nameMappings
		.filter(([profileField]) => profileField in profile)
		.map(
			([profileField, attrName]) => [attrName, profile[profileField]] as const,
		)
		.filter(([, value]) => value !== undefined && value !== null)
		.map(([attrName, value]) => ({
			Name: attrName,
			Value: value?.toString(),
		}));
}

export type { UpdatableUserProps };
export { profileToCognitoAttributes };
